import Box from '@mui/material/Box';
import { useContext, useEffect, useState } from 'react';
import '../../App.css';
import { Stack, Typography } from '@mui/material';
import RestfulManager, { RES_STATUS_OK } from '../../manager/RestfulManager';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import { Styles, StyleConstants } from '../../Styles';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import { TabContext, TabPanel } from '@mui/lab';
import CarSystemStatusTab from './CarSystemStatusTab';
import SmallFaultTable from '../../components/SmallFaultTable';
import CarSeatAvailabilityTab from './CarSeatAvailabilityTab';
import SnackbarContext from '../../components/SnackbarContext';
import { API_CALL_INTERVAL } from '../../config/Config';
import LrvStatusTable from '../../components/LrvStatusTable';
import RouteCanvas from '../../components/RouteCanvas';
import SpeedImage from '../../assets/images/Speed.png';
import FaultLightStatusStack from '../../components/FaultLightStatusStack';
import SessionManager from '../../manager/SessionManager';
import useInterval from '../../hook/useInterval';

const systemStatusMenuItems = [
    'Door System',
    'Traction System',
    'Auxiliary System',
    'Air Conditioning System',
    'VCC Status'
];

const routeImage = require('../../assets/images/route.png');
const carImage = require('../../assets/images/car.png');

const CarPage = () => {
    const { setOpenSnackBar, setSnackbarSeverity, setSnackbarMessage } = useContext(SnackbarContext);
    
    const sessionManager = new SessionManager();
    const restfulManager = new RestfulManager();

    const [cars, setCars] = useState([]);
    const [carCode, setCarCode] = useState('');

    const [carPageTab, setCarPageTab] = useState(0);

    const [packet, setPacket] = useState({});
    const [car, setCar] = useState({});
    const [runCode, setRunCode] = useState('');
    const [routeCode, setRouteCode] = useState('');
    const [stationName, setStationName] = useState('');
    const [speed, setSpeed] = useState('0.0');
    const [faults, setFaults] = useState([]);

    const [carPoss, setCarPoss] = useState([]);
    const [routeStations, setRouteStations] = useState([]);
    const [carFaults, setCarFaults] = useState([]);

    const [systemStatusMenuIndex, setSystemStatusMenuIndex] = useState(0);

    const systemStatusMenuSelectChange = (event) => {
        setSystemStatusMenuIndex(event.target.value);
    };

    const getCarByCarCode = async (carCode) => {
        try {
            const res = await restfulManager.getCarByCarCode(sessionManager.getAccessToken(), carCode);
            const json = await res.json();
            if ((res.status === 200) && (json.status === RES_STATUS_OK)) {
                setCar(json.car);
            } else {
                setCar([]);

                if (json && json.msg) {
                    setSnackbarSeverity('error');
                    setSnackbarMessage(json.msg);
                    setOpenSnackBar(true);
                }
            }
        } catch (e) {
            console.error(e);
            setSnackbarSeverity('error');
            setSnackbarMessage('Error. Please contact administrator.');
            setOpenSnackBar(true);
        }
    };

    const getRouteStationsByRouteCode = async (routeCode) => {
        try {
            let res = await restfulManager.getRouteStationsByRouteCode(sessionManager.getAccessToken(), routeCode);
            let json = await res.json();
            if ((res.status === 200) && (json.status === RES_STATUS_OK)) {
                if (json.routeStations) {
                    setRouteStations(json.routeStations);

                    res = await restfulManager.getCarPossByRouteCode(sessionManager.getAccessToken(), routeCode);
                    json = await res.json();
                    if ((res.status === 200) && (json.status === RES_STATUS_OK)) {
                        if (json.carPosDTOs) {
                            setCarPoss(json.carPosDTOs);
                        } else {
                            setCarPoss([]);
                        }
                        
                        if (json.carFaultDTOs) {
                            setCarFaults(json.carFaultDTOs);
                        } else {
                            setCarFaults([]);
                        }
                    } else {
                        setRouteStations([]);
                        setCarPoss([]);
                        setCarFaults([]);

                        if (json && json.msg) {
                            setSnackbarSeverity('error');
                            setSnackbarMessage(json.msg);
                            setOpenSnackBar(true);
                        }
                    }
                } else {
                    setRouteStations([]);
                }
            } else {
                if (json && json.msg) {
                    setSnackbarSeverity('error');
                    setSnackbarMessage(json.msg);
                    setOpenSnackBar(true);
                }
            }
        } catch (e) {
            console.error(e);
            setSnackbarSeverity('error');
            setSnackbarMessage('Error. Please contact administrator.');
            setOpenSnackBar(true);
        }
    };

    const loadCarData = async (carCode) => {
        try {
            if (carCode) {
                await getCarByCarCode(carCode);

                const res = await restfulManager.getCarPosByCarCode(sessionManager.getAccessToken(), carCode);
                const json = await res.json();
                if ((res.status === 200) && (json.status === RES_STATUS_OK)) {
                    if (json.packet) {
                        setPacket(json.packet);
                        setFaults(json.faultDTOs);
                    } else {
                        setPacket({});
                        setFaults({});
                    }

                    const carPos = json.carPosDTO;
                    if (carPos) {
                        setRunCode(carPos.runCode);
                        setRouteCode(carPos.routeCode);
                        setStationName(carPos.stationNameTc);
                        setSpeed(carPos.speed ? (carPos.speed === 0 ? '0.0' : carPos.speed) : '0.0');

                        if (carPos.routeCode) {
                            await getRouteStationsByRouteCode(carPos.routeCode);
                        }
                    } else {
                        setRunCode('');
                        setRouteCode('');
                        setStationName('');
                        setSpeed('0.0');
                    }
                } else {
                    setPacket({});
                    setFaults({});

                    setRunCode('');
                    setRouteCode('');
                    setStationName('');
                    setSpeed('0.0');

                    if (json && json.msg) {
                        setSnackbarSeverity('error');
                        setSnackbarMessage(json.msg);
                        setOpenSnackBar(true);
                    }
                }
            }
        } catch (e) {
            setPacket({});
            setFaults({});

            setRunCode('');
            setRouteCode('');
            setStationName('');
            setSpeed('0.0');

            console.error(e);
            setSnackbarSeverity('error');
            setSnackbarMessage('Error. Please contact administrator.');
            setOpenSnackBar(true);
        }
    };

    const carSelectChange = (event) => {
        const selectedCarCode = event.target.value;
        setCarCode(selectedCarCode);
    };

    const carPageTabChange = (event, newValue) => {
        setCarPageTab(newValue);
    };

    useEffect(() => {
        (async () => {
            try {
                const res = await restfulManager.getCars(sessionManager.getAccessToken());
                const json = await res.json();
                if ((res.status === 200) && (json.status === RES_STATUS_OK)) {
                    setCars(json.cars);

                    const defaultCar = json.cars[0];
                    setCar(defaultCar);
                    setCarCode(defaultCar.carCode);
                } else {
                    if (json && json.msg) {
                        setSnackbarSeverity('error');
                        setSnackbarMessage(json.msg);
                        setOpenSnackBar(true);
                    }
                }
            } catch (e) {
                console.error(e);
                setSnackbarSeverity('error');
                setSnackbarMessage('Error. Please contact administrator.');
                setOpenSnackBar(true);
            }
        })();
    }, []);

    useInterval(() => {
        loadCarData(carCode);
    }, API_CALL_INTERVAL, [carCode]);

    return (
        <>
            <Box sx={{ flexGrow: 1, padding: '8px' }}>
                <Stack direction="column">
                    <Stack direction="row" spacing={1}>
                        <Box sx={{ width: '630px', height: '70px', border: '3px solid ' + StyleConstants.borderColor, backgroundColor: StyleConstants.componentBgColor, color: StyleConstants.fontColor, marginTop: '4px', alignItems: 'center', alignContent: 'center' }}>
                            <Stack direction="row" sx={{ width: '100%', alignItems: 'center', alignContent: 'center', justifyContent: 'space-between' }}>
                                {routeCode && (
                                    <img
                                        src={ require('../../assets/images/route/' + routeCode + '.png') }
                                        style={{
                                            width: '550px',
                                            height: '44px',
                                            marginLeft: '8px',
                                        }}
                                        alt=""
                                    />
                                )}

                                <>
                                    &nbsp;
                                </>

                                <img
                                    src={routeImage}
                                    alt=""
                                    style={{
                                        marginRight: '8px',
                                    }}
                                />
                            </Stack>
                        </Box>

                        <Box sx={{ height: '70px', border: '3px solid ' + StyleConstants.borderColor, backgroundColor: StyleConstants.componentBgColor, color: StyleConstants.fontColor, marginTop: '4px', alignItems: 'center', alignContent: 'center' }}>
                            <Stack direction="row" sx={{ alignItems: 'center', alignContent: 'center', justifyContent: 'space-between' }}>
                                <Stack direction="row" sx={{ alignItems: 'center', alignContent: 'center' }}>
                                    <Typography sx={{ ...Styles.contentFont4, marginLeft: '8px', marginRight: '8px' }}>
                                        Car Number:
                                    </Typography>

                                    <Select
                                        value={carCode}
                                        onChange={carSelectChange}
                                        sx={
                                            Styles.carSelect
                                        }
                                        MenuProps={{
                                            sx: {
                                                "& .MuiMenuItem-root.Mui-selected": {
                                                    color: 'red',
                                                    backgroundColor: StyleConstants.mainBgColor,
                                                },
                                                "& .MuiMenuItem-root:hover": {
                                                    backgroundColor: StyleConstants.highlightBgColor,
                                                },
                                                "& .MuiMenuItem-root.Mui-selected:hover": {
                                                    backgroundColor: StyleConstants.highlightBgColor,
                                                },
                                            }
                                        }}
                                    >
                                        {cars.map((car) => (
                                            <MenuItem
                                                key={car.carCode}
                                                value={car.carCode}
                                                sx={Styles.carSelect}
                                            >
                                                <Typography sx={{ fontSize: Styles.contentFont4 }}>
                                                    {car.carCode}
                                                </Typography>
                                            </MenuItem>
                                        ))}
                                    </Select>
                                </Stack>

                                <img
                                    src={carImage}
                                    alt=""
                                    style={{
                                        marginLeft: '8px',
                                        marginRight: '8px',
                                    }}
                                />
                            </Stack>
                        </Box>

                        <FaultLightStatusStack />
                    </Stack>

                    <Box sx={{ width: '100%', height: '600px', textAlign: 'center', alignItems: 'center', alignContent: 'center' }}>
                        <Stack direction="row" sx={{ alignItems: 'center' }}>
                            <Stack direction="column" sx={{ width: '431px', height: '100%', alignItems: 'center', justifyContent: 'space-evenly', gap: 2 }}>
                                <Stack direction="row" sx={{ height: '180px', gap: 2 }}>
                                    <Stack direction="column">
                                        <Typography sx={{ ...Styles.contentFont3, width: '100px' }}>
                                            Run Number
                                        </Typography>
                                        <Typography sx={{ ...Styles.contentFont4 }}>
                                            {runCode}
                                        </Typography>
                                    </Stack>

                                    <Stack direction="column">
                                        <Typography sx={{ ...Styles.contentFont3 }}>
                                            Current Position
                                        </Typography>
                                        <Typography sx={{ ...Styles.contentFont4 }}>
                                            {stationName}
                                        </Typography>
                                    </Stack>

                                    <Stack direction="column">
                                        <Typography sx={{ ...Styles.contentFont3, width: '100px' }}>
                                            Route No.
                                        </Typography>
                                        <Typography sx={{ ...Styles.contentFont4 }}>
                                            {routeCode}
                                        </Typography>
                                    </Stack>
                                </Stack>

                                <Stack direction="row" sx={{ gap: 2, alignItems: 'center' }}>
                                    <img src={SpeedImage} alt="" style={{ width: '150px', height: '150px', textAlign: 'left' }} />

                                    <Stack direction="column" sx={{ width: '100%' }}>
                                        <Typography sx={{ ...Styles.contentFont3 }}>
                                            Speed
                                        </Typography>
                                        <Typography sx={{ ...Styles.contentFont4, width: '200px' }}>
                                            {speed} km/h
                                        </Typography>
                                    </Stack>
                                </Stack>
                            </Stack>

                            <Box sx={{ width: '1410px' }}>
                                {routeCode && (
                                    <RouteCanvas
                                        left="447px"
                                        top="180px"
                                        routeCode={routeCode}
                                        routeStations={routeStations}
                                        carPoss={carPoss}
                                        carFaults={carFaults}
                                        />
                                )}
                            </Box>
                        </Stack>
                    </Box>

                    <Stack direction="row" spacing={1}>
                        <Box sx={{
                            width: '820px',
                            height: '324px',
                            border: '3px solid ' + StyleConstants.borderColor,
                            backgroundColor: StyleConstants.componentBgColor,
                            color: StyleConstants.fontColor,
                            marginTop: '4px',
                        }}>
                            <Stack direction="column" sx={{ height: '100%', paddingLeft: '8px', paddingRight: '8px', textAlign: 'center', alignItems: 'center' }}>
                                <Typography sx={{ width: '100%', ...Styles.contentFont4, textAlign: 'left' }}>
                                    LRV Status
                                </Typography>

                                <LrvStatusTable isLoading={false} carFaults={carFaults} rowsPerPage={5} />
                            </Stack>
                        </Box>

                        <Box sx={{
                            marginTop: '4px',
                            marginLeft: '12px',
                            padding: '0px 8px',
                            width: '985px',
                            height: '324px',
                            border: '3px solid ' + StyleConstants.borderColor,
                            backgroundColor: StyleConstants.componentBgColor,
                            color: StyleConstants.fontColor
                        }}>
                            <TabContext value={String(carPageTab)}>
                                <Stack direction="column" sx={{ height: '100%' }}>
                                    <Stack direction="row" sx={{ justifyContent: 'space-between' }}>
                                        <Tabs
                                            value={carPageTab}
                                            onChange={carPageTabChange}
                                            sx={{
                                                "& .Mui-selected": {
                                                    backgroundColor: StyleConstants.highlightTabColor
                                                }
                                            }}
                                        >
                                            <Tab
                                                sx={{
                                                    textTransform: 'none',
                                                    fontSize: '20px',
                                                    border: '1px #8FAADC solid'
                                                }}
                                                label={<span style={{ color: '#FFFFFF' }}>System Status</span>}
                                                value={0}
                                            />
                                            <Tab
                                                sx={{
                                                    textTransform: 'none',
                                                    fontSize: '20px',
                                                    border: '1px #8FAADC solid'
                                                }}
                                                label={<span style={{ color: '#FFFFFF' }}>Fault List</span>}
                                                value={1}
                                            />
                                            <Tab
                                                sx={{
                                                    textTransform: 'none',
                                                    fontSize: '20px',
                                                    border: '1px #8FAADC solid'
                                                }}
                                                label={<span style={{ color: '#FFFFFF' }}>Seat Availability</span>}
                                                value={2}
                                            />
                                        </Tabs>

                                        <Select
                                            value={systemStatusMenuIndex}
                                            onChange={systemStatusMenuSelectChange}
                                            sx={Styles.carSystemStatusSelect}
                                            MenuProps={{
                                                sx: {
                                                    "& .MuiMenuItem-root.Mui-selected": {
                                                        color: 'red',
                                                        backgroundColor: StyleConstants.mainBgColor,
                                                    },
                                                    "& .MuiMenuItem-root:hover": {
                                                        backgroundColor: StyleConstants.highlightBgColor,
                                                    },
                                                    "& .MuiMenuItem-root.Mui-selected:hover": {
                                                        backgroundColor: StyleConstants.highlightBgColor,
                                                    }
                                                }
                                            }}
                                            inputProps={{
                                                classes: {
                                                    icon: StyleConstants.fontColor,
                                                    root: StyleConstants.fontColor,
                                                },
                                            }}
                                        >
                                            {systemStatusMenuItems.map((menuItem, index) => (
                                                <MenuItem
                                                    key={index}
                                                    value={index}
                                                    sx={Styles.carSystemStatusSelect}
                                                >
                                                    <Typography sx={{ fontSize: Styles.contentFont3 }}>
                                                        {menuItem}
                                                    </Typography>
                                                </MenuItem>
                                            ))}
                                        </Select>
                                    </Stack>

                                    {JSON.stringify(packet) !== JSON.stringify({}) && (
                                        <Box sx={{ height: '100%', backgroundColor: StyleConstants.componentBgColor, color: StyleConstants.fontColor }}>
                                            <TabPanel value={'0'} sx={{ height: '100%' }}>
                                                <CarSystemStatusTab packet={packet} car={car} systemStatusMenuIndex={systemStatusMenuIndex} />
                                            </TabPanel>
                                            <TabPanel value={'1'} sx={{ height: '100%' }}>
                                                <SmallFaultTable isLoading={false} faults={faults} rowsPerPage={3} />
                                            </TabPanel>
                                            <TabPanel value={'2'} sx={{ height: '100%' }}>
                                                <CarSeatAvailabilityTab packet={packet} />
                                            </TabPanel>
                                        </Box>
                                    )}
                                </Stack>
                            </TabContext>
                        </Box>
                    </Stack>
                </Stack>
            </Box>
        </>
    );
};

export default CarPage;